(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fsarcan-botanical-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const controllers = new Map();
  const clamp = value => Math.max(0, Math.min(1, value));
  const canvas = (width, height) => Object.assign(document.createElement('canvas'), { width, height });
  function prepare(source, cell, mode) {
    const width = 360, height = cell < 0 ? 540 : 360;
    const whole = canvas(width, height), ctx = whole.getContext('2d', { willReadFrequently: true });
    const sw = source.naturalWidth / (cell < 0 ? 1 : 2);
    const sh = source.naturalHeight / (cell < 0 ? 1 : 3);
    ctx.drawImage(source, cell < 0 ? 0 : cell % 2 * sw, cell < 0 ? 0 : Math.floor(cell / 2) * sh, sw, sh, 0, 0, width, height);
    const pixels = ctx.getImageData(0, 0, width, height);
    const stem = ctx.getImageData(0, 0, width, height);
    const ids = new Int8Array(width * height).fill(-1);
    const seeds = Array.from({ length: 30 }, (_, i) => ({
      x: (i % 5 + .35 + Math.sin(i * 7) * .2) * width / 5,
      y: (Math.floor(i / 5) + .4 + Math.cos(i * 5) * .2) * height / 6,
      left: width, top: height, right: 0, bottom: 0, count: 0
    }));
    for (let y = 0; y < height * .88; y++) {
      for (let x = 0; x < width; x++) {
        const p = (y * width + x) * 4;
        const r = pixels.data[p], g = pixels.data[p + 1], b = pixels.data[p + 2], a = pixels.data[p + 3];
        const green = g > r * 1.015 && g > b * 1.075;
        const bloom = !green && (r > g * 1.06 || b > g * 1.03 || Math.min(r, g, b) > 145);
        if (a < 24 || !(mode === 'leaves' ? green : bloom)) continue;
        let closest = 0, distance = Infinity;
        seeds.forEach((seed, i) => {
          const d = (seed.x - x) ** 2 + (seed.y - y) ** 2;
          if (d < distance) { closest = i; distance = d; }
        });
        ids[y * width + x] = closest;
        const seed = seeds[closest];
        seed.left = Math.min(seed.left, x); seed.right = Math.max(seed.right, x);
        seed.top = Math.min(seed.top, y); seed.bottom = Math.max(seed.bottom, y); seed.count++;
      }
    }
    const pieces = seeds.flatMap((seed, id) => {
      if (seed.count < 12) return [];
      const w = seed.right - seed.left + 1, h = seed.bottom - seed.top + 1;
      const texture = canvas(w, h), tctx = texture.getContext('2d');
      const data = tctx.createImageData(w, h);
      for (let y = seed.top; y <= seed.bottom; y++) {
        for (let x = seed.left; x <= seed.right; x++) {
          if (ids[y * width + x] !== id) continue;
          const p = (y * width + x) * 4, q = ((y - seed.top) * w + x - seed.left) * 4;
          data.data.set(pixels.data.subarray(p, p + 4), q);
          stem.data[p + 3] = 0;
        }
      }
      tctx.putImageData(data, 0, 0);
      return [{ texture, x: seed.left, y: seed.top, w, h, drift: Math.sin(id * 2.4) * 55, turn: Math.cos(id * 3.1) * .8 }];
    }).sort((a, b) => a.y - b.y);
    const base = canvas(width, height);
    base.getContext('2d').putImageData(stem, 0, 0);
    return { width, height, base, pieces };
  }
  function mount(root) {
    if (controllers.has(root)) return;
    const ground = root.querySelector('[data-botanical-family]');
    if (!ground) return;
    const abort = new AbortController(), options = { passive: true, signal: abort.signal };
    const sprigs = [...ground.querySelectorAll('.pd-botanical-sprig')];
    const states = new Map(sprigs.map(el => [el, { el, state: 'full', context: null, output: null }]));
    let textures, preparation, active = null, armed = null, frame = 0, down = null, disposed = false;
    const reduced = () => media.matches || Boolean(root.closest('.pd-reduced,.cp-reduced')) || document.hidden;
    async function load() {
      if (textures) return textures;
      if (!preparation) preparation = (async () => {
        const source = ground.querySelector('img');
        await source.decode();
        textures = prepare(source, Number(ground.dataset.botanicalCell), ground.dataset.botanicalMode);
        return textures;
      })().catch(() => null);
      return preparation;
    }
    function restore() {
      cancelAnimationFrame(frame); frame = 0; active = null; armed = null;
      states.forEach(s => { s.state = 'full'; s.el.dataset.botanicalState = 'full'; });
    }
    function draw(s, elapsed, growing) {
      const { width, height, base, pieces } = textures;
      const ctx = s.context;
      ctx.clearRect(0, 0, width, height + 200);
      ctx.drawImage(base, 0, 0);
      pieces.forEach((piece, i) => {
        const delay = (growing ? pieces.length - i - 1 : i) * 32;
        const p = clamp((elapsed - delay) / (growing ? 2300 : 1400));
        if (!growing && p === 1) return;
        const ease = 1 - (1 - p) ** 3;
        ctx.save();
        if (growing) {
          ctx.globalAlpha = ease;
          ctx.translate(piece.x + piece.w * .5, piece.y + piece.h);
          ctx.scale(.08 + ease * .92, .08 + ease * .92);
          ctx.rotate((1 - ease) * piece.turn * .25);
          ctx.drawImage(piece.texture, -piece.w * .5, -piece.h);
        } else {
          ctx.globalAlpha = 1 - clamp((p - .38) / .62);
          ctx.translate(piece.x + piece.w / 2 + Math.sin(p * Math.PI) * piece.drift, piece.y + piece.h / 2 + p * p * 185);
          ctx.rotate(p * piece.turn);
          ctx.scale(1 - p * .15, 1 - p * .3);
          ctx.drawImage(piece.texture, -piece.w / 2, -piece.h / 2);
        }
        ctx.restore();
      });
    }
    async function activate(el) {
      if (active || disposed || reduced()) return;
      const s = states.get(el);
      active = s;
      const result = await load();
      if (!result || disposed || reduced() || active !== s) { restore(); return; }
      if (!s.output) {
        s.output = canvas(result.width, result.height + 200);
        s.output.className = 'pd-botanical-canvas';
        s.output.style.height = `${(result.height + 200) / result.height * 100}%`;
        s.context = s.output.getContext('2d');
        el.append(s.output); el.dataset.botanicalReady = 'true';
      }
      const growing = s.state === 'bare';
      s.state = growing ? 'growing' : 'falling'; el.dataset.botanicalState = s.state;
      const start = performance.now();
      const duration = (growing ? 2300 : 1400) + result.pieces.length * 32;
      function tick(now) {
        const rect = el.getBoundingClientRect();
        if (disposed || reduced() || rect.bottom < 0 || rect.top > innerHeight) { restore(); return; }
        draw(s, Math.min(duration, now - start), growing);
        if (now - start < duration) { frame = requestAnimationFrame(tick); return; }
        s.state = growing ? 'full' : 'bare'; el.dataset.botanicalState = s.state; active = null; frame = 0;
      }
      frame = requestAnimationFrame(tick);
    }
    function hit(event) {
      if (reduced() || event.target.closest('.pd-wrap,a,button,input,select,textarea,dialog')) return null;
      const edge = Math.max(44, Math.min(140, innerWidth * .095));
      if (event.clientX > edge && event.clientX < innerWidth - edge) return null;
      return sprigs.find(el => {
        const r = el.getBoundingClientRect();
        return event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      });
    }
    root.addEventListener('pointermove', event => {
      if (event.pointerType !== 'mouse' || !fine.matches) return;
      const el = hit(event);
      if (!el) { armed = null; return; }
      if (armed === el || active) return;
      armed = el; activate(el);
    }, options);
    root.addEventListener('pointerleave', () => { armed = null; }, options);
    root.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse') return;
      down = { x: event.clientX, y: event.clientY, scroll: scrollY, time: performance.now(), el: hit(event) };
    }, options);
    root.addEventListener('pointerup', event => {
      if (!down || event.pointerType === 'mouse') return;
      if (down.el && hit(event) === down.el && Math.hypot(event.clientX - down.x, event.clientY - down.y) < 8 && Math.abs(scrollY - down.scroll) < 4 && performance.now() - down.time < 350) activate(down.el);
      down = null;
    }, options);
    root.addEventListener('pointercancel', () => { down = null; }, options);
    document.addEventListener('visibilitychange', restore, options);
    media.addEventListener('change', restore, { signal: abort.signal });
    const observer = new MutationObserver(() => { if (reduced()) restore(); });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    const shell = root.closest('.cp');
    if (shell) observer.observe(shell, { attributes: true, attributeFilter: ['class'] });
    const cleanup = () => { disposed = true; restore(); abort.abort(); observer.disconnect(); controllers.delete(root); };
    controllers.set(root, cleanup);
    if (fine.matches && !reduced()) {
      const warm = () => { if (!disposed && !reduced()) load(); };
      if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 });
      else setTimeout(warm, 1800);
    }
  }
  const boot = () => document.querySelectorAll('[data-product-root]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => controllers.forEach((cleanup, root) => { if (event.target.contains(root)) cleanup(); }));
})();
  } catch(e) { console.error(e); }
})();

})();
